var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUpdate = function SvgUpdate(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 7.6V2.8c0-2.4-2.8-3.4-4.8-2.4l-17.6 10c-2.1 1-2.1 3.8 0 4.8l17.6 10c2.1 1 4.8-.3 4.8-2.4v-5.5c17.6 1 31.3 14.5 31.3 31.3 0 7.2-2.8 14.5-7.9 20-.7.7-.7 1.7 0 2.4l4.8 4.5c.7.7 2.1.7 2.8 0 6.9-7.2 10.3-16.9 10.3-26.5C93.2 26.6 75 8.7 51.5 7.6M53.6 74.8c-2.1-1-4.8.3-4.8 2.4v5.5c-17.6-1-31.3-14.8-31.3-31.3 0-7.2 2.8-14.5 7.9-20 .7-.7.7-1.7 0-2.4l-5.2-4.5c-.7-.3-2.1-.3-2.8.3-6.8 7.3-10.3 16.6-10.3 26.6 0 22 18.6 40 41.7 41v4.8c0 2.4 2.8 3.4 4.8 2.4l17.6-10c2.1-1 2.1-3.8 0-4.8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUpdate);
export default ForwardRef;